function getTooltipContentFirstLine(htmlString: string): string {
  const extracted = htmlString.split(/<br\s*\/?>/);
  const firstLine = extracted[0];
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = firstLine;
  const keyName = tempDiv.textContent || tempDiv.innerText || '';
  return keyName;
}

export default getTooltipContentFirstLine;
